// extracted by mini-css-extract-plugin
export default {"box":"statusBox_box__GM7UC","titleTop":"statusBox_titleTop__OOf0p","title":"statusBox_title__9QqT7","titleImg":"statusBox_titleImg__JAis9"};